export default "__VITE_ASSET__CxYI9xZg__"